module.exports = __webpack_public_path__ + "img/pantalla-8-7.a02aff04.png";